const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    main: true,
    props: {
      filterName: "supplier_name_contains",
      label: "Supplier",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/CurrencyFilter"),
    props: {
      filterName: "currency_code_eq",
      label: "Supplier Currency",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/HeadOfficeFilter"),
    main: true,
    props: {
      filterName: "headofficeId",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "agent_name_contains",
      label: "Agent",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "client_name_contains",
      label: "Client",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "client_reference_contains",
      label: "Iti Client Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    main: true,
    props: {
      filterName: "itinerary_ref_contains",
      label: "Itinerary Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    main: true,
    props: {
      filterName: "internal_ref_contains",
      label: "Internal Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "external_ref_contains",
      label: "Supplier Invoice Number",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Inv Number",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/NumberComparatorFilter"),
    props: {
      filterName: "amount",
      label: "Inv Amount",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/NumberComparatorFilter"),
    props: {
      filterName: "balance",
      label: "Balance Amount",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/NumberComparatorFilter"),
    props: {
      filterName: "totalAdjustments",
      label: "Total Adjustments",
    },
  },

  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/SupplierTypeFilter"),
    props: {
      filterName: "serviceType",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BrandMultiFilter"),
    props: {
      filterName: "brands_eq",
      label: "Brand",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DepartmentMultiFilter"),
    props: {
      filterName: "departments_eq",
      label: "Department",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () =>
      import("../../shared/list-filters/InternalStatusMultiFilter"),
    props: {
      filterName: "internalStatus_eq",
      label: "Internal Status",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DestinationFilter"),
    props: {
      filterName: "destination_id",
      label: "Supplier Destination",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "destination_name_contains",
      label: "Destination Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    main: true,
    props: {
      filterName: "iti_start_date",
      label: "Itinerary start date between",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "service_start_date",
      label: "Service start date between",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "iti_end_date",
      label: "Itinerary end date between",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/ItineraryStatusFilter"),
    props: {
      filterName: "itineraryStatuses_eq",
      label: "Itinerary Status",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "created_at",
      label: "Created at date between",
    },
  },

  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    main: true,
    props: {
      filterName: "approved_eq",
      label: "Approved",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "exported_eq",
      label: "Exported",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/PaymentMethodFilter"),
    props: {
      filterName: "paymentMethod_eq",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    main: true,
    props: {
      filterName: "supplier_invoice_date",
      label: "Supplier Invoice date between",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/finances/purchase-invoices/purchase-invoices-filters.js